import React from 'react';
import { MenuItem, ListItemText } from '@mui/material';
import { Checkbox } from '../../Checkbox/Checkbox';
import { HighlightText } from './HighlightText';

interface Option {
  value: string;
  label: string;
}

interface OptionsListProps {
  options: Option[];
  selectedValues: string[];
  searchText: string;
  onOptionClick: (value: string) => void;
}

export const OptionsList: React.FC<OptionsListProps> = ({
  options,
  selectedValues,
  searchText,
  onOptionClick,
}) => (
  <>
    {options.map((option) => (
      <MenuItem key={option.value} value={option.value} onClick={() => onOptionClick(option.value)}>
        <Checkbox checked={selectedValues.includes(option.value)} />
        <ListItemText primary={<HighlightText text={option.label} search={searchText} />} />
      </MenuItem>
    ))}
  </>
);
